import React, { useMemo, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import { useTranslation, Trans } from 'react-i18next';
import SeoHreflang from '../components/SeoHreflang';
import logo_rus from '../assets/logo_rus.png';
import logo_eng from '../assets/logo_eng.png';
import logo_esp from '../assets/logo_esp.png';
import logo_zh from '../assets/logo_zh.png';
import i18n from "../i18n";
import { Link } from "react-router-dom";
import SiteHeader from '../components/SiteHeader';
import ReCAPTCHA from 'react-google-recaptcha';
import { API_URL } from "../config";
import footerDoc1 from '../assets/footer-doc1.docx';
import footerDoc2 from '../assets/footer-doc2.docx';

const LanguageSwitcher = React.lazy(() => import('..//components/LanguageSwitcher'));


const BASE_ITEMS = [
  { type: 'link', label: 'Реестр готовых решений', path: 'registry' },
  { type: 'link', label: 'Обучение лучших практик', path: 'courses' },
  { type: 'link', label: 'Маркетплейс готовых решений', path: 'marketplace' },
  { type: 'link', label: 'Книга лучших практик', path: 'book' },
];

function ProductMenu() {
  const { lang } = useParams();        // <-- текущий язык из URL
  const currentLang = lang || 'ru';    // fallback

  const productItems = BASE_ITEMS.map(item => ({
    ...item,
    to: `/${currentLang}/${item.path}`, // <-- добавляем префикс
  }));

  return (
    <nav>
      {productItems.map(item => (
        <Link key={item.to} to={item.to}>{item.label}</Link>
      ))}
    </nav>
  );
}

/**
 * RegistryLanding.jsx — React + Tailwind, self‑contained landing page component
 * Секциями и контентом повторяет загруженную HTML‑страницу «Реестр решений».
 * Подключите Tailwind в проекте, затем поместите файл в `src/components/` и используйте как обычный компонент.
 */
export default function RegistryPage() {
  const [captcha, setCaptcha] = useState(null);
  const [loading, setLoading] = useState(false);
  const recaptchaRef = useRef(null);

  const { t } = useTranslation();
  // === Constants ===
  const DOCS_COUNT = 240;
  const REGISTRY_PRICE_RUB = 3_500_000; // 3.5 млн ₽
  const [pricePerDocMln, setPricePerDocMln] = useState(3); // млн ₽ за документ у консультантов

  // === Derived values ===
  const perDocPriceRub = useMemo(() => Math.round(REGISTRY_PRICE_RUB / DOCS_COUNT), []);
  const consultingTotalRub = useMemo(() => pricePerDocMln * 1_000_000 * DOCS_COUNT, [pricePerDocMln]);
  const savingsRub = useMemo(() => consultingTotalRub - REGISTRY_PRICE_RUB, [consultingTotalRub]);
  const consultingBar = 100;
  const registryBar = useMemo(() => Math.max((REGISTRY_PRICE_RUB / consultingTotalRub) * 100, 2), [consultingTotalRub]);

  const brands = [
  t('Subheader455a1'),
  t('Subheader455a2'),
  t('Subheader455a3'),
  t('Subheader455a4'),
  t('Subheader455a5'),
  t('Subheader455a6'),
];

const cases = [
  {
    sector: t('RBPCases1a'),
    result: t('RBPCases1b'),
    detail: t('RBPCases1c'),
    impact: t('RBPCases1d'),
  },
  {
    sector: t('RBPCases2a'),
    result: t('RBPCases2b'),
    detail: t('RBPCases2c'),
    impact: t('RBPCases2d'),
  },
  {
    sector: t('RBPCases3'),
    result: t('RBPCases3a'),
    detail: t('RBPCases3b'),
    impact: t('RBPCases3c'),
  },
];


  const onSubmitForm = async (e) => {
    e.preventDefault();
    if (!captcha) {
      alert('Подтвердите, что вы не робот');
      return;
    }
    const fd = new FormData(e.currentTarget);
    const payload = {
      name:    fd.get('name'),
      email:   fd.get('email'),
      phone:   fd.get('phone'),
      channel: fd.get('channel'),
      message: fd.get('message'),
      captcha, // токен
    };

    try {
      setLoading(true);
      const res = await fetch(`${API_URL}/contact/`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });

      if (res.ok) {
        alert('Сообщение отправлено!');
        e.currentTarget.reset();
        setCaptcha(null);
        recaptchaRef.current?.reset(); // сбросить виджет
      } else {
        const err = await res.json().catch(() => ({}));
        alert(`Ошибка отправки${err?.message ? `: ${err.message}` : ''}`);
        recaptchaRef.current?.reset();
        setCaptcha(null);
      }
    } finally {
      setLoading(false);
    }
  };

  const logoMap = { ru: logo_rus, en: logo_eng, es: logo_esp, zh: logo_zh };
  const lang = (i18n.resolvedLanguage || i18n.language || 'ru').slice(0,2);
  const currentLogo = logoMap[lang] || logo_eng;

  return (
    <div className="min-h-screen bg-white text-gray-900">
      <SeoHreflang />
      {/* Header */}
<SiteHeader
  pageLinks={[
    { label: t('linkRBP1'), href: '#roi' },
    { label: t('linkRBP2'), href: '#inside' },
    { label: t('linkRBP3'), href: '#cases' },
    { label: t('linkRBP4'), href: '#contact' },
    { label: t('linkMP5'),  href: '#faq' },
  ]}
  cta={[{ label: t('ButtonRBP2'), to: `/registry#contact` }]}
/>

      {/* <header className="sticky top-0 z-40 bg-white/90 backdrop-blur border-b border-gray-100">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
          <Link to="/" style={{height: '100%'}}>
              <img src={currentLogo} style={{ height: '100%', width: 'auto' }} alt="logo"/>
        </Link>
          <nav className="hidden md:flex items-center gap-6 text-sm">
            <a href="#roi" className="hover:text-purple-600">{t('linkRBP1')}</a>
            <a href="#inside" className="hover:text-purple-600">{t('linkRBP2')}</a>
            <a href="#cases" className="hover:text-purple-600">{t('linkRBP3')}</a>
            <a href="#contact" className="hover:text-purple-600">{t('linkRBP4')}</a>
            <a href="#faq" className="hover:text-purple-600">{t('linkMP5')}</a>
          </nav>
          <a href="#contact" className="inline-flex items-center justify-center rounded-xl px-4 py-2 text-sm font-semibold bg-purple-600 text-white hover:bg-purple-700 transition">
            {t('ButtonRBP2')}
          </a>
          <ProductMenu />
          <LanguageSwitcher />
        </div>
      </header> */}

      {/* Hero */}
      <section className="relative overflow-hidden">
        {/* soft blobs */}
        <div className="absolute inset-0 pointer-events-none" aria-hidden>
          <div className="absolute -right-24 -top-24 h-64 w-64 rounded-full bg-purple-100 blur-3xl opacity-60" />
          <div className="absolute -left-24 -bottom-24 h-64 w-64 rounded-full bg-indigo-100 blur-3xl opacity-60" />
        </div>

        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-14">
          <div className="grid lg:grid-cols-2 gap-10 items-center">
            <div>
              <div className="inline-flex items-center gap-2 rounded-full border border-gray-200 px-3 py-1 text-xs text-gray-600 mb-4">
                <span className="inline-block h-2 w-2 rounded-full bg-purple-600" /> {t('Header44a')}
              </div>
              <h1 className="text-4xl sm:text-5xl font-extrabold leading-tight tracking-tight">
                <Trans
                i18nKey="Header44"
                components={{ span: <span className="bg-gradient-to-r from-purple-700 to-indigo-600 bg-clip-text text-transparent" /> }}
                />
                {/* <span className="bg-gradient-to-r from-purple-700 to-indigo-600 bg-clip-text text-transparent">Экономьте миллионы и месяцы</span> — 240 готовых решений вместо консультантов */}
              </h1>
              <p className="mt-4 text-lg text-gray-700">
                <Trans
                i18nKey="Subheader441"
                components={{ b: <strong  /> }}
                />
                {/* Возьмите весь пакет лучших практик за <strong>{t('RBP_TotalProjectcost2')}</strong> и запустите изменения уже на этой неделе. Без найма дорогих специалистов. */}
              </p>

              <div className="mt-6 grid grid-cols-2 gap-3 max-w-md">
                <div className="rounded-2xl border border-gray-200 bg-white p-4">
                  <div className="text-xs text-gray-500">{t('Subheader441a')}</div>
                  <div className="mt-1 text-2xl font-extrabold">{perDocPriceRub.toLocaleString("ru-RU")} ₽</div>
                  <div className="mt-1 text-xs text-gray-500">{t('Subheader441c')}</div>
                </div>
                <div className="rounded-2xl border border-gray-200 bg-white p-4">
                  <div className="text-xs text-gray-500">{t('Subheader441d')}</div>
                  <div className="mt-1 text-2xl font-extrabold">{t('Subheader441e')}</div>
                  <div className="mt-1 text-xs text-gray-500">{t('Subheader441f')}</div>
                </div>
              </div>

              <div className="mt-8 flex flex-col sm:flex-row gap-3">
                <a href="#contact" className="inline-flex items-center justify-center rounded-2xl px-6 py-3 text-base font-semibold bg-purple-600 text-white hover:bg-purple-700 transition shadow-[0_10px_25px_rgba(0,0,0,.06)]">
                  {t('ButtonRBP2')}
                </a>
                <a href="#roi" className="inline-flex items-center justify-center rounded-2xl px-6 py-3 text-base font-semibold bg-gray-900/5 hover:bg-gray-900/10 transition">
                  {t('ButtonRBP3')}
                </a>
              </div>

              <div className="mt-6 flex flex-wrap items-center gap-6 text-sm text-gray-600">
                <Feature>{t('RBP_Access')}</Feature>
                <Feature>{t('RBP_LicenseForCompany')}</Feature>
                <Feature>{t('RBP_receive8')}</Feature>
              </div>
            </div>

            {/* ROI Card */}
            <div className="relative" id="roi">
              <div className="rounded-3xl border border-gray-100 shadow-[0_10px_25px_rgba(0,0,0,.06)] p-6 bg-white">
                <h3 className="text-lg font-semibold">{t('Header45')}</h3>
                <p className="mt-1 text-sm text-gray-600">{t('Subheader451')}</p>

                <div className="mt-4">
                  <label htmlFor="slider" className="text-sm text-gray-700">
                    <Trans 
                    i18nKey="Subheader452"
                    />
                    {pricePerDocMln}
                    {t('mln')} ₽
                  </label>
                  <input
                    id="slider"
                    type="range"
                    min={2}
                    max={7}
                    step={0.1}
                    value={pricePerDocMln}
                    onChange={(e) => setPricePerDocMln(parseFloat(e.target.value))}
                    className="w-full accent-purple-600 mt-2"
                  />
                  <div className="flex justify-between text-[11px] text-gray-500 mt-1">
                    <span>2 {t('mln')}</span><span>7 {t('mln')}</span>
                  </div>
                </div>

                <div className="mt-5 grid md:grid-cols-2 gap-4">
                  <div className="rounded-2xl border border-gray-100 p-4">
                    <div className="text-xs text-gray-500">{t('Subheader452b')}</div>
                    <div className="mt-1 text-2xl font-extrabold">{(consultingTotalRub / 1_000_000).toLocaleString("ru-RU")} {t('mln')} ₽</div>
                    <div className="mt-3 h-3 rounded-full bg-gray-100">
                      <div className="h-3 rounded-full bg-indigo-600" style={{ width: consultingBar + "%" }} />
                    </div>
                    <div className="mt-2 text-xs text-gray-500">
                      {t('Subheader452d')}
                      {pricePerDocMln} {t('mln')} ₽
                    </div>
                  </div>
                  <div className="rounded-2xl border border-gray-100 p-4">
                    <div className="text-xs text-gray-500">{t('Subheader452e')}</div>
                    <div className="mt-1 text-2xl font-extrabold">{t('Subheader452f')}</div>
                    <div className="mt-3 h-3 rounded-full bg-gray-100">
                      <div className="h-3 rounded-full bg-purple-600" style={{ width: registryBar + "%" }} />
                    </div>
                    <div className="mt-2 text-xs text-gray-500">{t('Subheader452g')}</div>
                  </div>
                </div>

                <div className="mt-4 rounded-2xl bg-gradient-to-r from-purple-700 to-indigo-600 text-white p-5">
                  <div className="text-sm/5 opacity-90">{t('Subheader453')}</div>
                  <div className="text-3xl font-extrabold tracking-tight">{((consultingTotalRub - REGISTRY_PRICE_RUB) / 1_000_000).toLocaleString("ru-RU")} {t('mln')} ₽</div>
                  <div className="mt-1 text-xs opacity-90">{t('Subheader455')}</div>
                </div>
              </div>
            </div>
          </div>

          {/* Brand strip */}
          <div className="mt-12 rounded-3xl border border-gray-100 bg-white p-5">
            <div className="text-xs uppercase text-gray-500">{t('Subheader455a')}</div>
            <div className="mt-3 grid sm:grid-cols-3 lg:grid-cols-6 gap-3 text-sm text-gray-700">
              {brands.map((b) => (
                <div key={b} className="rounded-xl border border-gray-200 py-2 px-3 text-center">{b}</div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* What's inside */}
      <section id="inside" className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-10">
        <h2 className="text-2xl sm:text-3xl font-bold tracking-tight">{t('Header46')}</h2>
        <p className="mt-3 text-gray-600">{t('RBP_receive')}</p>
        <div className="mt-8 grid md:grid-cols-2 lg:grid-cols-4 gap-4">
          {[
            { title: t('RBP_receive1'), text: t('RBP_receive1a') },
            { title: t('RBP_receive2'), text: t('RBP_receive2a') },
            { title: t('RBP_receive3'), text: t('RBP_receive3a') },
            { title: t('RBP_receive4'), text: t('RBP_receive4a') },
            { title: t('RBP_receive5'), text: t('RBP_receive5a') },
            { title: t('RBP_receive6'), text: t('RBP_receive6a') },
            { title: t('RBP_receive7'), text: t('RBP_receive7a') },
            { title: t('RBP_receive8'), text: t('RBP_receive8a') },
          ].map((item) => (
            <div key={item.title} className="rounded-3xl border border-gray-200 bg-white p-5">
              <div className="flex items-start gap-3">
                <div className="mt-0.5"><CheckIcon className="h-4 w-4 text-green-600" /></div>
                <div>
                  <div className="text-sm font-medium text-gray-800">{item.title}</div>
                  <div className="text-sm text-gray-600 mt-1">{item.text}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Cases */}
      <section id="cases" className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-10">
        <h2 className="text-2xl sm:text-3xl font-bold tracking-tight">{t('Header47')}</h2>
        <p className="mt-3 text-gray-600">{t('RBPCases1')}</p>
        <div className="mt-6 grid md:grid-cols-3 gap-4">
          {cases.map((c) => (
            <div key={c.sector} className="rounded-3xl border border-gray-200 bg-white p-6">
              <div className="text-xs text-gray-500">{c.sector}</div>
              <div className="mt-1 text-2xl font-extrabold">{c.result}</div>
              <div className="mt-1 text-sm text-gray-600">{c.detail}</div>
              <div className="mt-3 text-sm font-medium text-gray-800">{c.impact}</div>
            </div>
          ))}
        </div>
      </section>

      {/* Contact form */}
      <section id="contact" className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-10">
        <div className="rounded-3xl border border-gray-200 bg-white p-6 md:p-8">
          <div className="grid lg:grid-cols-2 gap-8 items-start">
            <div>
              <h2 className="text-2xl sm:text-3xl font-bold tracking-tight">{t('Header48')}</h2>
              <p className="mt-3 text-gray-600">{t('SubHeader48a')}</p>

              <ul className="mt-6 space-y-3 text-sm text-gray-700">
                <li className="flex gap-2 items-start"><CheckIcon /> <span>
                  <Trans 
                  i18nKey="SubHeader48a1"
                  components={{em: <em />}}
                  />
                  </span></li>
                <li className="flex gap-2 items-start"><CheckIcon /> <span>{t('SubHeader48a2')}</span></li>
                <li className="flex gap-2 items-start"><CheckIcon /> <span>{t('SubHeader48a3')}</span></li>
              </ul>

              <div className="mt-6 rounded-2xl bg-gradient-to-r from-purple-700 to-indigo-600 text-white p-5">
                <div className="text-sm/5 opacity-90">{t('RBP_TotalProjectcost1')}</div>
                <div className="text-3xl font-extrabold tracking-tight">{t('RBP_TotalProjectcost2')}</div>
                <div className="mt-1 text-xs opacity-90">{t('RBP_TotalProjectcost3')}</div>
              </div>
            </div>

            <form className="space-y-4" onSubmit={onSubmitForm}>
              <div>
                <label className="block text-sm font-medium text-gray-700">{t('RBP_Form_Name')}</label>
                <input required name="name" type="text" className="mt-1 w-full rounded-xl border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-purple-600" placeholder={t('RBP_Form_NameFill')} />
              </div>
              <div className="grid sm:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700">{t('RBP_Form_ConnectFill1')}</label>
                  <input required name="email" type="email" className="mt-1 w-full rounded-xl border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-purple-600" placeholder="you@company.ru" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">{t('RBP_Form_EmailFill')}</label>
                  <input name="phone" type="text" className="mt-1 w-full rounded-xl border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-purple-600" placeholder="+7 900 000-00-00 / @username" />
                </div>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">{t('RBP_Form_Connect')}</label>
                <select name="channel" className="mt-1 w-full rounded-xl border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-purple-600">
                  <option>{t('RBP_Form_ConnectFill1')}</option>
                  <option>{t('RBP_Form_ConnectFill2')}</option>
                  <option>{t('RBP_Form_ConnectFill3')}</option>
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">{t('RBP_Form_Message')}</label>
                <textarea name="message" rows={4} className="mt-1 w-full rounded-xl border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-purple-600" placeholder={t('RBP_Form_MessageFill')}></textarea>
              </div>
              <ReCAPTCHA
                ref={recaptchaRef}
                sitekey="6Lcyn9orAAAAALZDHh2-tU_mlCJ_rUgrrHiW0UzR" 
                onChange={(t) => {
                  console.log('captcha token =', t, t?.length); // должно быть ~300–1000 символов
                  setCaptcha(t);}}
              />
              <button type="submit" disabled={!captcha || loading} className="w-full rounded-2xl bg-purple-600 text-white px-6 py-3 font-semibold hover:bg-purple-700 transition">{t('ButtonRBP4')}</button>
              <p className="text-xs text-gray-500">{t('RBP_SendText')}</p>
            </form>
          </div>
        </div>
      </section>

      {/* {t('linkMP5')} */}
      <section id="faq" className="mx-auto max-w-5xl px-4 sm:px-6 lg:px-8 py-12">
        <h2 className="text-2xl sm:text-3xl font-bold tracking-tight">{t('Header49')}</h2>
        <div className="mt-6 divide-y divide-gray-200 border border-gray-200 rounded-3xl overflow-hidden">
          {[
            { q: t('RBP_FAQ1'), a: t('RBP_FAQ1a') },
            { q: t('RBP_FAQ2'), a: t('RBP_FAQ2a') },
            { q: t('RBP_FAQ3'), a: t('RBP_FAQ3a') },
            { q: t('RBP_FAQ4'), a: t('RBP_FAQ4a') },
          ].map((f) => (
            <details key={f.q} className="group open:bg-gray-50">
              <summary className="list-none cursor-pointer select-none p-5 hover:bg-gray-50 flex items-start justify-between gap-4">
                <span className="font-semibold text-gray-900">{f.q}</span>
                <span className="text-gray-400 group-open:rotate-45 transition">＋</span>
              </summary>
              <div className="px-5 pb-5 text-sm text-gray-700">{f.a}</div>
            </details>
          ))}
        </div>
      </section>

      {/* Footer */}
      <footer className="border-t border-gray-100">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-8 text-sm text-gray-500 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <div>© {new Date().getFullYear()} {t('RBP_GenRef')}</div>
          <div className="flex gap-6">
            <a href={footerDoc2} download={`${t('$UserAgr')}.docx`} style={{textDecoration: 'none', color: 'black'}} className="hover:text-gray-700">
              <p>
                  {t('$UserAgr')}
              </p>
          </a>
          <a href={footerDoc1} download={`${t('$Pol')}.docx`} style={{textDecoration: 'none', color: 'black'}} className="hover:text-gray-700">
              <p>
                  {t('$Pol')}
              </p>
          </a>
            <a className="hover:text-gray-700" href="mailto:sales@best-practices.online">sales@best-practices.online</a>
          </div>
        </div>
      </footer>
    </div>
  );
}

// === Small UI helpers ===
function CheckIcon({ className = "h-4 w-4 text-green-600" }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden>
      <path fillRule="evenodd" d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm13.36-2.59a.75.75 0 10-1.22-.88l-3.26 4.52-1.51-1.51a.75.75 0 10-1.06 1.06l2.19 2.19c.33.33.86.28 1.13-.11l3.73-5.27z" clipRule="evenodd" />
    </svg>
  );
}

function Feature({ children }) {
  return (
    <div className="flex items-center gap-2"><CheckIcon /> <span>{children}</span></div>
  );
}